import { inject, injectable } from "inversify";
import HttpService from "src/services/http.service";
import IdentityService from "./identity.service";
import ToastService from "./toast.service";
import { IFileSystemService } from "../typings";
import {ImageService, OpenAPI} from "./openapi/generated";

@injectable()
export default abstract class BaseFileSystemService implements IFileSystemService {

    protected abstract get uploadUrl(): string;
    @inject(HttpService)
    public httpService: HttpService;

    @inject(IdentityService)
    public identityService: IdentityService;

    @inject(ToastService)
    public toastService: ToastService;

    public async handleError(error: Response) {
        if (error.status >= 401 && error.status < 500) {
            let errors: React.ReactNode[] = [];

            errors.push(error.statusText);
            errors.push(error.url);
            /*for(var k in json)
                errors.push(`${k}:  ${json[k]}`);*/

            this.toastService.showToast("Error " + error.status, errors, "error");

            return;
        } else if (error.status >= 500) {
            let js = await error.text();
            this.toastService.showToast("Error " + error.status, `${error.statusText} ${error.url} ${js}`, "error");
        }
    }

    public async getFile<T>(id: any): Promise<T> {
        if (this.private()) {
            return ImageService.imageControllerGetPrivateImage(id);
        } else {
            return ImageService.imageControllerGetImage(id);
        }
    }

    public async uploadFile<T>(data: any): Promise<any> {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + OpenAPI.TOKEN);

        const formdata = new FormData();
        formdata.append("file", data, data.name);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
        };
        if (this.private()) {
            const res = await fetch("https://encrypto.art/api/image/private", requestOptions);
            return res.json();
        } else {
            const res = await fetch("https://encrypto.art/api/image/", requestOptions);
            return res.json();
        }
    }

    protected abstract getUrl(id: any): string;

    protected abstract private(): boolean;

    protected abstract getFileImageName(): string;

    protected abstract getHeaders(): any;

    protected operationUp() {
        (window as any).store.dispatch({ type: "AJAX_OPERATION_UP" });
    }

    protected operationDown() {
        (window as any).store.dispatch({ type: "AJAX_OPERATION_DOWN" });
    }
}



// WEBPACK FOOTER //
// ./src/services/filesystem.base.service.ts